define.alias("shared/helpers/get-attachment-url", "media/helpers/get-attachment-url");